import { useEffect, useState } from 'react';
import styles from './detailCellRender.module.css';
import reserveManagementApi, { ReserveManagementDetailList, ReserveManagementItem } from '../../services/http/reserveManagement.api';
import Spinner from '../../components/Spinner';
import { ApiError } from '../../services/http';
import { STATUS_MESSAGES } from '../../utils/messages';

export interface DetailCellRendererProps extends ReserveManagementItem {
  pinned?: string | null;
}

/**
 * 文書詳細セル表示のコンポーネント
 */
function DetailCellRenderer({ reserveNo, type, pinned }: DetailCellRendererProps) {
  const hidden = pinned === 'left';
  // STATES
  const [reserveManagementDetailList, setReserveManagementDetailList] = useState<ReserveManagementDetailList[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<ApiError | null>(null);

  async function request(reserveManagementItem: ReserveManagementItem): Promise<void> {
    setLoading(true);
    try {
      const doc = await reserveManagementApi.getReserveManagementDetail(reserveManagementItem);
      setReserveManagementDetailList(doc);
    } catch (e) {
      setError(e as ApiError);
      throw e;
    } finally {
      setLoading(false);
    }
  }

  // Initial State
  useEffect(() => {
    request({ reserveNo, type });
  }, []);

  return (
    <div className={styles['detail-row-container']}>
      {loading && reserveManagementDetailList.length === 0 && (
      <div className={hidden ? styles['loading-row-hidden'] : styles['loading-row']}>
        { !hidden && <Spinner size={25} />}
      </div>
      )}
      {!loading && reserveManagementDetailList.length === 0 && (
      <div className={hidden ? styles['loading-row-hidden'] : styles['loading-row']}>
        { !hidden && STATUS_MESSAGES.NO_DATA }
      </div>
      )}
      { reserveManagementDetailList.map((item) => (
        <div className={styles['detail-row']} key={item.documentName}>
          <div className={`${styles['detail-row-item']} ${hidden ? styles.hidden : ''}`}>
            <label>文書ID：</label>
            <span title={item.ccControlNumber?.toString() ?? ''}>{item.ccControlNumber}</span>
          </div>
          <div className={`${styles['detail-row-item']} ${hidden ? styles.hidden : ''}`}>
            <label>文書名：</label>
            <span title={item.documentName ?? ''}>{item.documentName}</span>
          </div>
          <div className={`${styles['detail-row-item']} ${hidden ? styles.hidden : ''}`}>
            <label>文書種類：</label>
            <span title={item.documentTypeName ?? ''}>{item.documentTypeName}</span>
          </div>
          <div className={`${styles['detail-row-item']} ${hidden ? styles.hidden : ''}`}>
            <label>バーコード印字欄：</label>
            <span title={item.barcodePrinting ?? ''}>{item.barcodePrinting}</span>
          </div>
          <div className={`${styles['detail-row-item']} ${hidden ? styles.hidden : ''}`}>
            <label>保管品バーコード：</label>
            <span title={item.itemCode ?? ''}>{item.itemCode}</span>
          </div>
          <div className={`${styles['detail-row-item']} ${hidden ? styles.hidden : ''}`}>
            <label>フォルダ：</label>
            <span title={item.folderName ?? ''}>{item.folderName}</span>
          </div>
          <div className={`${styles['detail-row-item']} ${hidden ? styles.hidden : ''}`}>
            <label>登録者：</label>
            <span title={item.registerUser ?? ''}>{item.registerUser}</span>
          </div>

        </div>
      ))}
    </div>
  );
}

export default DetailCellRenderer;
